{
  "activeCases": "Aktive sager",
  "activeLoans": "Aktive lån",
  "archivedCases": "Arkiverede sager",
  "case.allocation.accordion.allocationName": "Bevillingsnavn",
  "case.allocation.accordion.allocationName.placeholder": "Angiv bevillingsnavn",
  "case.allocation.accordion.information": "Oplysninger til bevillingssag",
  "case.allocation.accordion.loan.review": "Review af nyt udlån",
  "case.allocation.accordion.loanPurpose": "Låneformål",
  "case.allocation.accordion.maxTimeToMaturity": "Maksimal løbetid (juridisk)",
  "case.allocation.accordion.maxTimeToMaturity.error.exceeds": "Overstiger tilladt maksimal løbetid",
  "case.allocation.accordion.maxTimeToMaturity.placeholder": "Angiv løbetid",
  "case.allocation.accordion.originalAmount": "Bevillingsstørrelse ",
  "case.allocation.accordion.originalAmount.placeholder": "Angiv bevillingsstørrelse ",
  "case.allocation.accordion.subTitle": "Status på bevilling og review",
  "case.allocation.accordion.title": "Bevilling og review",
  "case.calculation.changePhaseState.modal.title": "Skift nuværende status på beregningsfasen",
  "case.caseInformation_one": "Sagsinformation",
  "case.caseInformation_other": "Sagsinformationer",
  "case.caseNumber": "Sagsnummer",
  "case.casePhase": "Fase",
  "case.caseResponsible": "Ansvarlig",
  "case.caseState": "Status",
  "case.close.banner.title": "Sagen er afsluttet {{date}}",
  "case.close.button": "Afslut $t(common:case_one)",
  "case.close.modal.comment.label": "Skriv kommentar (valgfrit)",
  "case.close.modal.comment.placeholder": "Uddyb årsag",
  "case.close.modal.description": "Når sagen afsluttes, annulleres igangværende aktiviteter og sagen fjernes fra sagsoverblikket. Du vil stadig kunne tilgå den under kundens arkiverede sager.",
  "case.close.modal.primaryAction.label": "Afslut sag",
  "case.close.modal.reason.label": "Årsag til afslutning",
  "case.close.modal.reason.placeholder": "Vælg årsag",
  "case.close.modal.success": "Sag afsluttet",
  "case.close.modal.title": "Du er ved at afslutte sagen",
  "case.contact.success": "Kontaktperson tilknyttet",
  "case.create.allocation.existing.allocationAmount": "Bevillingsstørrelse",
  "case.create.allocation.existing.allocationName": "Bevillingsnavn",
  "case.create.allocation.existing.caseNumber": "Sagsnummer",
  "case.create.allocation.existing.remainingAmount": "Resterende bevilling",
  "case.create.allocation.existing.search.placeholder": "Søg efter tidligere bevilling",
  "case.create.allocation.new.allocationName.label": "Bevillingsnavn",
  "case.create.allocation.new.allocationName.placeholder": "Skriv navnet på bevillingen",
  "case.create.allocation.new.loanPurpose.label": "Låneformål",
  "case.create.allocation.new.loanPurpose.placeholder": "Hvad er formålet med lånet?",
  "case.create.allocation.pick.existing": "Eksisterende bevilling",
  "case.create.allocation.pick.new": "Ny bevilling",
  "case.create.allocation.pick.title": "Vælg bevilling",
  "case.create.modal.pickContact.label": "Kontaktperson",
  "case.create.modal.pickContact.noneAvailable.description": "Opret kontaktperson for at starte sag",
  "case.create.modal.pickContact.noneAvailable.title": "Ingen kontakter tilknyttet kunden",
  "case.create.modal.pickContact.title": "Vælg kontaktperson",
  "case.create.modal.pickLoan.search.placeholder": "Søg efter aftalenummer",
  "case.create.modal.pickLoan.title": "Vælg aftale",
  "case.create.orientation.title": "Vedhæft beregninger til orientering",
  "case.create.orientation.description": "Her kan du sende en orientering til kunden med vedhæftede beregninger. Vælg rentebindingsperiode for beregningerne nedenfor, eller send uden beregninger.",
  "case.create.orientation.sendWithoutCalculations": "Send uden beregninger",
  "case.create.orientation.close": "Luk uden at sende",
  "case.create.orientation.sendStep.title": "Send orientering til kunde",
  "case.create.orientation.sendStep.button": "Send orientering",
  "case.create.orientation.sendStep.backButton": "Vedhæft beregninger",
  "case.create.orientation.sendStep.card": "Orientering om udløb af renteaftale",
  "case.create.success": "Sagen er oprettet",
  "case.create.swap.warning.modal.description": "Bemærk, at både låneaftalen og den tilknyttede renteswap skal behandles ved grundlæggende ændringer af aftalen.",
  "case.create.swap.warning.modal.primaryAction": "Fortsæt sagsoprettelse",
  "case.create.swap.warning.modal.title": "Renteswap tilknyttet låneaftalen",
  "case.displayAmount": "Beløb",
  "case.eventType": "Hændelsestype",
  "case.infoAndAllocationNotYetComplete": "Sagsinformationer og bevilling er endnu ikke gennemført",
  "case.infoNotYetComplete": "Sagsinformationer er endnu ikke gennemført",
  "case.installment.title": "Indfrielse",
  "case.legalName": "Kunde",
  "case.new.initiateKyc.success": "KYC er igangsat",
  "case.takeover.button": "Overtag sag",
  "case.takeover.modal.confirmation": "Du er ved at overtage sag fra:",
  "case.takeover.modal.title": "Overtagelse af {{ caseId }}",
  "case.takeover.success": "Du er nu sagsansvarlig for {{ caseId }}",
  "caseHistory": "Sagshistorik",
  "caseHistory.none": "Ingen sagshistorik er tilgængelig",
  "caseOverview": "sagsoversigt",
  "closedCase": "Afsluttet sag",
  "customerType": "Kundetype",
  "days_one": "{{ count }} dag",
  "days_other": "{{ count }} dage",
  "deadlines": "Frister",
  "EntitledSigner": "Tegningsberettiget",
  "signed": "Underskrevet",
  "signing.notification.daysToDeadline_one": "{{count}} dag til deadline",
  "signing.notification.daysToDeadline_other": "{{count}} dage til deadline",
  "signing.notification.overdue": "Underskrift overskredet",
  "signer_one": "Underskriver",
  "signer_other": "Underskrivere",
  "signing_one": "Underskrift",
  "signing_other": "Underskrifter",
  "signingPage.caseClosed.message": "Se sagsinformationer for detaljer",
  "signingPage.caseClosed.title": "Sagen er afsluttet inden underskrift",
  "signingPage.customerByLaws.success": "Kundens underskrivere er opdateret",
  "signingPage.document.LoanDocument": "Gældsbrev",
  "signingPage.document.NewInterestAgreementLoanDocument": "Tillæg til låneaftale",
  "signingPage.document.AllongeToPromissoryNote": "Tillæg til låneaftale",
  "signingPage.document.PowerOfAttorney": "Fuldmagt",
  "signingPage.guarantorByLaws.success": "Garantistillers underskrivere er opdateret",
  "signingPage.pendingMessage.newLoan": "Gældsbrevet er endnu ikke klar til underskrift",
  "signingPage.pendingMessage.newInterestAgreement": "Tillæg til låneaftale er endnu ikke klar til underskrift",
  "signingPage.remindContact": "Påmind kontaktperson",
  "signingPage.remindContact.success": "Påmindelse sendt",
  "signingPage.superUser.banner.button": "Flyt frist for underskrift",
  "signingPage.superUser.banner.headline": "Flyt frist for underskrift og udbetalingsdato",
  "signingPage.superUser.banner.message": "Hvis kunden ikke kan nå at underskrive inden seneste frist for underskrift, kan fristen forlænges efter aftale med kunden.\nUdbetalingsdatoen skal flyttes i overensstemmelse med den nye frist.",
  "signingPage.superUser.modal.payoutDate": "Ny udbetalingsdato",
  "signingPage.superUser.modal.signingDeadline": "Ny frist for underskrifter",
  "signingPage.superUser.modal.subheading": "Hvis kunden ikke kan nå at underskrive inden seneste frist for underskrift, kan fristen forlænges efter aftale med kunden. Udbetalingsdatoen flyttes i overensstemmelse med den nye frist",
  "signingPage.superUser.modal.title": "Flyt frist for underskrift og udbetalingsdato",
  "signingPage.tab.company": "Kunde",
  "signingPage.tab.guarantor": "Garantistiller",
  "signingPage.tab.overview": "Overblik",
  "signingPage.unavailableByLaws": "Vedtægterne er ikke tilgængelige",
  "signingRules": "Tegningsregler"
}
